import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ROOT_URL } from "../../api/ApiConfig";

function authHeaders(getState) {
  const { loginToken, loginTokenCoUser } = getState();
  const token = loginToken?.response?.token || loginTokenCoUser?.response?.token;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
}

export const fetchTicketRoutingByGroup = createAsyncThunk(
  "ticketRouting/fetchByGroup",
  async ({ groupId }, { getState, rejectWithValue }) => {
    if (!groupId) {
      return rejectWithValue({ message: "Missing group id" });
    }
    try {
      const response = await axios.get(
        `${ROOT_URL}/ticket-routing/admin/group/${groupId}`,
        authHeaders(getState),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  },
);

export const updateTicketRoutingByGroup = createAsyncThunk(
  "ticketRouting/updateByGroup",
  async ({ groupId, body }, { getState, rejectWithValue }) => {
    if (!groupId) {
      return rejectWithValue({ message: "Missing group id" });
    }
    try {
      const response = await axios.put(
        `${ROOT_URL}/ticket-routing/admin/group/${groupId}`,
        body,
        authHeaders(getState),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  },
);

const initialState = {
  group: null,
  teams: [],
  ticketRouting: null,
  loading: false,
  saving: false,
  error: null,
};

const ticketRoutingApi = createSlice({
  name: "ticketRouting",
  initialState,
  reducers: {
    clearTicketRouting: () => initialState,
    clearTicketRoutingError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTicketRoutingByGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.teams = [];
        state.ticketRouting = null;
      })
      .addCase(fetchTicketRoutingByGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.group = action.payload?.group ?? null;
        state.teams = Array.isArray(action.payload?.teams) ? action.payload.teams : [];
        state.ticketRouting = action.payload?.ticket_routing ?? null;
      })
      .addCase(fetchTicketRoutingByGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.group = null;
        state.teams = [];
        state.ticketRouting = null;
      })
      .addCase(updateTicketRoutingByGroup.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateTicketRoutingByGroup.fulfilled, (state, action) => {
        state.saving = false;
        if (action.payload?.ticket_routing) {
          state.ticketRouting = action.payload.ticket_routing;
        }
        if (Array.isArray(action.payload?.teams)) {
          state.teams = action.payload.teams;
        }
      })
      .addCase(updateTicketRoutingByGroup.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { clearTicketRouting, clearTicketRoutingError } = ticketRoutingApi.actions;
export default ticketRoutingApi.reducer;
